import { Asset } from 'base/asset';
import { Avatar as AvatarComponent } from 'base/ui/avatar';
import { AvatarGroup } from 'base/ui/avatar_group';
import { Tooltip } from 'base/ui/tooltip';
import { PresenceTracker } from 'blocks/sync/presence_tracker';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from './presence.css';

const getContainerStyle = (background: 'grey' | 'white') => {
  return background === 'grey' ? styles.grey : styles.white;
};

export const PresenceAvatars = observer(function _PresenceAvatars({
  presence,
  maxAvatars,
  background,
  overlapAvatars,
  bordered,
}: {
  presence: Pick<PresenceTracker, 'sessions' | 'mySessionId'>;
  maxAvatars: number;
  background: 'grey' | 'white';
  bordered: boolean;
  overlapAvatars?: boolean;
}) {
  return (
    <AvatarGroup
      avatars={presence.sessions.map((session) => ({
        id: session.sessionId,
        user: session.user,
        color: session.color,
        self: session.sessionId === presence.mySessionId,
      }))}
      background={background}
      maxVisible={maxAvatars}
      bordered={bordered}
      overlap={overlapAvatars}
    />
  );
});

// TODO: Delete this
// @deprecated
export function Avatar({
  color,
  isMe,
  user,
  size,
  bordered,
  background,
}: {
  color: string;
  user?: { firstName: string; lastName: string; avatar?: Asset } | undefined;
  isMe: boolean;
  size: 'medium' | 'small';
  bordered: boolean;
  background: 'grey' | 'white';
}) {
  const ref = React.useRef<HTMLElement>(null);

  let tooltipText = user
    ? `${user.firstName} ${user.lastName}`.trim()
    : 'Anonymous';
  if (isMe) {
    tooltipText += ' (you)';
  }

  return (
    <div className={classNames(styles.avatar, getContainerStyle(background))}>
      <AvatarComponent
        ref={ref}
        size={size}
        color={color}
        bordered={bordered}
        isAnonymous={!user}
        {...user}
      />
      <Tooltip anchorRef={ref} label={tooltipText} placement="vertical" />
    </div>
  );
}
